import { gql } from '@apollo/client';

export default class DocumentTypeMutation {
    static UPDATE_DOCUMENT_TYPE = gql`
        mutation updateDocumentType($documentId: Int!, $documentType: String!) {
            updateDocumentType(documentId: $documentId, documentType: $documentType)
        }
    `
}
